<template>
  <span class="justify-start d-flex flex-column align-center">
    <v-avatar size="200">
      <v-img
        v-if="icon"
        :src="icon"
        :lazy-src="require('@/assets/img/logo.png')"
      />
      <v-img v-else src="http://placeimg.com/400/500/any" alt="avatar-img" />
    </v-avatar>
    <p class="mt-4 text-center font-weight-semibold">{{ name }}</p>
    <div class="text-center mt-n3">
      <div v-for="number of tel" :key="number">
        <a :href="`tel:${number.split('[')[0]}`">{{ number }}</a>
      </div>
    </div>
  </span>
</template>

<script>
export default {
  name: 'Contact',
  props: ['name', 'icon', 'tel']
}
</script>

<style></style>
